const Locale = {
  document_title: "Панель заказов - QRWaiter",
  choose_language: "Выберите язык:",
  login: {
    title: "Вход в очередь заказов",
    enter_qid_pin: "Введите qID заведения и Ваш PIN-код",
    enter_pin: "PIN-код",
    qid_ph: "ID заведения",
    enter_shared: "Общая очередь",
  },
  navbar: {
    queue: "Очередь заказов",
    archive: "История чеков",
    tables: "Залы и столы",
    orders: "Заказы",
    notifs: "Уведомления",
    support: "Техническая поддержка",
    stoplist: "Стоп-лист",
    switch_new: "Перейти в новую версию",
    logout_confirm: "Вы действительно хотите выйти из системы?",
    logout: "Выход",
  },
  queue: {
    connecting_title: "Подключение к очереди заказов, пожалуйста подождите...",
    connecting_desc:
      "Если подключение длится слишком долго - попробуйте позже или обратитесь в тех. поддержку.",
    create_order: "Создать новый заказ",
    no_orders: "Заказов в этой вкладке ещё нет.",
    check_history: "Просмотреть историю",
    creating_order_message: "Создание нового заказа",

    shared_queue: "Общая очередь",
    not_your_order:
      "Вы не можете выполнить это действие над заказом другого официанта.",
    modes_not_setup:
      "Чтобы получить доступ к очереди заказов, настройте нужные режимы в админ. панели заведения.",
  },
  tabs: {
    new: "Новые",
    processing: "В процессе",
    done: "Оплата",
    calendar: "Календарь",
  },
  card: {
    client: "Клиент:",
    total: "Всего:",
    comment: "Комментарий:",
    discount: "Скидка:",
    pay_method: "Метод оплаты:",
    reason: "Причина отказа:",

    append: "Дозаказ",
    append_accepted_at: "Был принят",
    append_accepted_now: "Был принят только что",

    pay_methods: {
      cash: "Наличными",
      card: "Терминалом",
      online: "Онлайн",
      bonus: "Бонусы",
    },

    descriptions: {
      waiting: "Новый заказ ожидает:",
      serving: "Обслуживается:",
      serving_timer: "К подаче:",
      served: "Подано",
      paying: "Неоплачено...",
      executed: "Оплачено.",
      editing: "Редактирование",
    },

    pay_status: "Статус оплаты:",
    paid: "Оплачено",
    unpaid: "Неоплачено",

    geolocation_not_verified:
      "Внимание! Этот заказ не прошел проверку геолокации.",

    to_pay: "К оплате:",
  },
  waiting: {
    title: "Укажите время приготовления",
    title_hotel: "Укажите время ожидания",
    time: "мин",
    hours: "ч",
    not_required: "Время приготовления выбирать необьязательно.",
    exact_time: "Указать точное время",
  },
  status: {
    table_no: "Стол",
    hall: "Зал",
    room: "Номер",
  },
  actions: {
    accept: "Принять",
    cancel: "Отклонить",
    pay: "Оплатить",
    edit: "Редактировать заказ",
    move: "Пересадить за другой стол",
    options: "Опции",

    split: "Разделить",
    merge: `Объединить`,
    close: "Закрыть чек",
    unlock: "Разблокировать",
    return: "Отменить оплату",
    add_dish: "Добавить блюдо",
    serve: "Подано",
    self_serve: "Готово",

    to_inside: "Перевести в INSIDE",

    unlock_desc1: "Клиент оплачивает заказ онлайн.",
    unlock_desc2: "Этот чек будет закрыт автоматически.",

    preorder_accept: "Принять",
    preorder_served: "Подано",
    preorder_sent: "Отправлено",
  },

  pay: {
    set_discount: "Скидка:",
    by_cash: "Наличными",
    by_card: "Терминалом",
  },

  add_dish: {
    title: "Выберите блюдо или напиток:",
    choose_modificators: "Выберите дополнения:",
    choose_variant: "Выберите вариант:",
    add_to_cart: "Добавить к чеку",
    add_many: "Чек",

    go_to_cart: "Перейти в чек",
    dishes_count: "блюдо | блюда",

    back: "Назад",
    add: "Добавить",
  },

  choose_table: {
    title: "Выберите стол:",
    accept: "Выбрать стол",
    small_hint: "Выберите стол",
    move: "Пересадить за выбраный стол",
  },

  edit: {
    title: "Редактировать чек",
    add_dish: "Добавить блюдо",

    cancel: "Отмена",
    save: "Сохранить",
  },

  merge: {
    title: `Объединение чеков:`,
    cancel: "Отмена",
    confirm: `Объединить`,
  },

  refuse: {
    title_some: "Вы отказываете клиенту в подаче {amount} блюд(а)",
    title_all: "Вы отказываете клиенту в подаче всех блюд",

    enter_reason: "Укажите причину:",

    enter_reason_ph: "Напишите причину",

    reasons: {
      stock: "Блюд(а) нет в наличии",
      age: "Продажа алкоголя несовершеннолетним лицам запрещена",
      custom: "Другое",
    },

    delete_reason: "Официант удалил чек",

    refund_warning:
      "Внимание: при отмене заказа средства будут возвращены клиенту согласно правилам платежной системы Вашего заведения.",

    cancel: "Назад",
    confirm: "Отменить заказ",
  },

  split: {
    title: "Разделение чека",
    cancel: "Отмена",
    confirm: "Разделить",
  },

  create_order: {
    confirm: "Создать заказ",
    cart: "Корзина",
    choose_dish: "Выберите блюдо",
    check_order: "Проверьте правильность заказа",
  },

  archive: {
    tabs: {
      cash: "Наличка",
      card: "Терминал",
      online: "Онлайн",
    },
    modes: {
      list: "История",
      summary: "Выписка",
    },
    no_checks: "Чеков в архиве с таким методом оплаты ещё нет.",
    pay_method: "Способ оплаты:",

    summary: {
      total: "Всего:",
      discount: "Сумма скидки:",
      tips: "Чаевые:",
    },
  },
  tables: {
    loading: "Загрузка...",
    loading_text: "Наши дизайнеры рисуют сетку Ваших столов, подождите...",

    table_no: "Стол №",

    titles: {
      move: "Пересадить",
      join: `Объеденить`,
    },

    actions: {
      merge: `Объеденить чеки`,
      join: `Объеденить столы`,
      disjoin: `Разъединить столы`,
      move: "Пересадить за другой стол",
      join_empty: `Объеденить с другим столом`,
    },
    action_messages: {
      merge: "Объединение столов",
      merge_description:
        "Выберите стол, с которым хотите объединить текущий стол",
      move: "Перемещение чека",
      move_description: "Выберите стол, на который хотите переместить чек",
    },

    confirm: {
      move: "Пересадить",
      join: `Объеденить`,
    },

    table_empty: "Пустой",

    noun_checks: {
      singular: "чек",
      plural: "чека",
      plural_2: "чеков",
    },
  },
  friendly_dates: {
    today: "Сегодня",
    tomorrow: "Завтра",
  },
  create_preorder: {
    name_ph: `Имя`,
    address_ph: "Адрес",
    asap: "Как можно скорее",
    date_ph: "Выберите дату и время",
    no_guests: "Без приборов",
    payment_ph: "Способ оплаты",
    payment_cash: "Наличными",
    payment_card: "Терминалом",
    to_order: "Перейти к заказу",
    comment_ph: "Вы можете оставить комментарий к заказу.",
    takeaway: "С собой",
    with_reservation: "+ бронь столика",

    details_types: {
      flat: "Квартира",
      floor: "Этаж",
      entrance: `Подъезд`,
    },

    fill_fields: "Заполните все поля.",
    create_btn: "Создать заказ",

    bonus_balance: "БОНУСНЫЙ БАЛАНС",
  },
  preorder_card: {
    phone: "Моб. номер:",
    takeaway: "Клиент желает получить заказ в:",
    date: "Дата:",
    address: "Адрес:",
    serve_date: "Время выдачи:",
    time: "Время заказа:",

    serve_plus: "через",
    serve_minus: "назад",

    action_edit: "Редактировать",
    action_cancel: "Отменено",

    wait_limit: "У Вас 15 минут, чтобы принять заказ.",
    send_desc:
      "Отметьте заказ как отправленный, чтобы гость получил уведомление.",
    delivery_autoclose:
      "Чек закроется автоматически, после того как заказ будет доставлен.",
    preorder_autoclose: "Чек закроется автоматически через 30 с.",

    action_close: "Закрыть заказ",

    takeaway_warning:
      "Внимание! Это заказ наперед, обратите внимание на время получения.",
    paid_by_bonuses: "Заказ оплачен с помощью бонусов.",

    with_takeaway: "С собой",
    with_reservation: "+ бронь столика",

    delivery_cost: "+ Доставка",
    delivery_cost_taxi: "+ Доставка, которая оплачивается при получении",
  },
  delivery_order_car: {
    title: "Машина будет через:",
    action: "Заказать машину",
  },
  delivery_driver: {
    title: "Информация о водителе:",
    phone: "Моб. номер",
    car: "Номер авто:",
    warning: "Ни один водитель не принял заказ. Телефон диспетчера доставки:",
  },
  errors: {
    title:
      "Произошла ошибка. Пожалуйста, обновите страницу или перезайдите в очередь заказов.",
    codes: {},
  },
  reserve: {
    header: "Бронь стола",
    card_guests_count: "человек | человека",
    card_reserve_time: "Время брони:",
    card_reserve_date: "Дата брони:",
    card_phone: "Моб. номер:",
    card_accept: "Принять",
    card_cancel: "Отменить бронь",
    card_accepted: "Стол забронирован, Вам также прийдет уведомление.",
  },
  reserve_calendar: {
    today: "Сегодня",
    yesterday: "Вчера",
    tomorrow: "Завтра",
  },
  units: {
    guests: "набор | набора",
    reserve_guests: "человек | человека",
    kg: "кг",
    g: "г",
    l: "л",
    ml: "мл",
  },
  preorder_status_bar: {
    accept_desc: "Для принятия заказа",
    serve_desc: "До выдачи",
    accept_local: "Ожидает принятия",
    send_desc: "До отправки",
    pay_status: "Статус оплаты",
    paid: "Оплачено",
    unpaid: "Не оплачено",
    served: "Выдано",
    sent: "Отправлено",
    creating: "Создание...",
  },
  inside_status_bar: {
    accept_desc: "Ожидает подтверджения",
    serve_desc: "До подачи",
    served: "Подано",
    serving: "Готовится...",
    splitting: "Разделение чека...",
    editing: "Редактирование...",
  },
  logout: {
    confirm: "Вы действительно хотите выйти с панели заказов?",
  },
  item_list: {
    weight_input: "Вес",
  },
  delete_dish: {
    title: "Удалить блюдо?",
    confirm: "Продолжить",
    cancel: "Отменить",
  },
  stoplist: {
    tab_editor: "МЕНЮ",
    tab_stoplist: "СТОП-ЛИСТ",
    search_ph: "Поиск...",

    type_dish: "Блюдо",

    stoplisted: "Добавлено в стоп-лист",
  },
};

export default Locale;
